document.addEventListener('DOMContentLoaded', () => {
  /* FAQs */
  faqs();
});

const FAQ_HEADER_GAP = 24;
const FAQ_LAYOUT_STABLE_FRAMES = 2;
const FAQ_LAYOUT_MAX_FRAMES = 30;

/**
 * Returns the current sticky header height plus a fixed gap, so scrolled
 * content isn't hidden behind the header.
 */
function getFaqHeaderOffset() {
  const header = document.querySelector('.js-header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;

  return headerHeight + FAQ_HEADER_GAP;
}

/**
 * Toggles the visibility of FAQ answers on user interaction.
 * When a question is clicked, the function closes all other questions
 * by removing their 'is-active' class, and toggles the clicked question's
 * 'is-active' class to expand or collapse its answer.
 */
function faqs() {
  const faqSections = document.querySelectorAll('.js-faqs-section');

  faqSections.forEach(faqSection => {
    const questions = faqSection.querySelectorAll('.question-js');

    questions.forEach(question => {
      question.addEventListener('click', () => {
        // Close all other questions
        questions.forEach(sItem => {
          if (sItem !== question) { // Skip the current question
            sItem.classList.remove('is-active');
          }
        });

        // Toggle the current question
        question.classList.toggle('is-active');

        if (question.classList.contains('is-active')) {
          waitForLayoutToSettle(question, () => scrollQuestionIntoView(question));
        }
      });
    });
  });
}

/**
 * Runs `callback` once the accordion's expand/collapse layout shift has
 * finished moving `element`, instead of guessing at the transition duration.
 */
function waitForLayoutToSettle(element, callback) {
  let lastTop = null;
  let stableFrames = 0;
  let frame = 0;

  function check() {
    const top = element.getBoundingClientRect().top;

    if (lastTop !== null && Math.abs(top - lastTop) < 0.5) {
      stableFrames++;
    } else {
      stableFrames = 0;
    }

    lastTop = top;
    frame++;
    window.__faqDebug = window.__faqDebug || [];
    window.__faqDebug.push({ t: Date.now() - (window.__faqClickTime || Date.now()), frame, top, stableFrames });

    if (stableFrames >= FAQ_LAYOUT_STABLE_FRAMES || frame >= FAQ_LAYOUT_MAX_FRAMES) {
      callback();
      return;
    }

    requestAnimationFrame(check);
  }

  requestAnimationFrame(check);
}

/**
 * Scrolls the FAQ question title into view if it's hidden behind the sticky
 * header or below the viewport, leaving it untouched if already visible.
 */
function scrollQuestionIntoView(question) {
  const headerOffset = getFaqHeaderOffset();
  const rect = question.getBoundingClientRect();
  const isAboveViewport = rect.top < headerOffset;
  const isBelowViewport = rect.bottom > window.innerHeight;

  if (!isAboveViewport && !isBelowViewport) return;

  const top = rect.top + window.scrollY - headerOffset;
  window.scrollTo({ top, behavior: 'smooth' });
}
